import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import { usePublicSiteBrandingAssets } from "@Front/Services/PublicSiteConfig/usePublicSiteBrandingAssets";
import { isPublicSiteEnsoLine } from "@Front/Utils/publicSiteBranding";
import classes from "../classes.module.scss";

type StepEmailHeaderProps = {
	welcomeTitle: string;
	welcomeSubtitle: string;
};

export default function StepEmailHeader({ welcomeTitle, welcomeSubtitle }: StepEmailHeaderProps): React.JSX.Element {
	const { logoSmallUrl } = usePublicSiteBrandingAssets();
	const showCenterBrandMark = !isPublicSiteEnsoLine();
	return (
		<div className={classes["header"]}>
			{showCenterBrandMark && <img src={logoSmallUrl} alt="Logo" height={56} width={56} />}
			<Typography typo={ETypo.TITLE_H1} color={ETypoColor.TEXT_ACCENT}>
				{welcomeTitle}
			</Typography>
			<Typography typo={ETypo.TITLE_H5}>{welcomeSubtitle}</Typography>
		</div>
	);
}
